import React, { FC } from 'react';
import { NewWysiwygFeedback } from './NewWysiwygFeedback';
import { groupCanSeeTrajectoryMapper } from '../../../../config/api/models/Group';
import { useCachedFetch } from '../../../shared';
import { useParams } from 'react-router';
import { UrlParams } from '../../../shared/types';
import apiRoutes from '../../../../config/api/routes';
import { useTranslation } from 'react-i18next';
import { IGroupStudent } from 'src/config/api/models/User';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';

type NewFeedbackProps = {
  pageId: string;
  blockId?: string;
  onSuccess: () => void;
  selectedGroupData?: IGroupStudent[];
};

export const NewFeedback: FC<NewFeedbackProps> = ({
  pageId,
  blockId,
  onSuccess,
  selectedGroupData,
}) => {
  const { t } = useTranslation();
  const { trajectoryId } = useParams<UrlParams>();
  const selectedGroup = useAppSelector((state) => state.filters.selectedGroup);
  const groupCanSeeTrajectoryFetch = useCachedFetch(
    ['groupCanSeeTrajectory', selectedGroup, trajectoryId as string],
    apiRoutes.groupCanSeeTrajectory(selectedGroup || '', trajectoryId as string),
    {
      mapper: groupCanSeeTrajectoryMapper,
      options: {
        enabled: selectedGroup !== undefined && selectedGroup !== '',
        cacheTime: 1000,
      },
    }
  );

  if (groupCanSeeTrajectoryFetch.data == null) return null;

  return groupCanSeeTrajectoryFetch.data.status ? (
    <NewWysiwygFeedback
      pageId={pageId}
      blockId={blockId}
      onSuccess={onSuccess}
      selectedGroupData={selectedGroupData}
    />
  ) : (
    <div>{t('feedback.groupCannotSeeTrajectoryVersion')}</div>
  );
};
